import { types, getEnv, applySnapshot } from 'mobx-state-tree'
import { localStorageMixin } from 'mst-gql'
import { RootStoreBase } from 'models/RootStore.base'
// import { selectFromCreateBookingPayload } from 'models/CreateBookingPayloadModel.base'
import { selectFromSaveTripDetailsPayload } from 'models/SaveTripDetailsPayloadModel.base'

import ViewStore from './ViewStore'

export const BOOKING = selectFromSaveTripDetailsPayload().errors.booking(
  (booking) =>
    booking.action.address.address2.altPhone.arrivalDate.availabilityId.availableSites.bookedAt.bookingNumber.bookingQuoteId.bookingRequestId.bookingSuccess.bookingUuid.cancelledAt.ccType.ccExpiry.ccNum4.city.country.createdAt.departureDate.depositRequiredCents.depositRequiredCurrency.discountText.email.firstName.heldAt.holdDepositCents.holdDepositCurrency.holdDuration.holdSuccess.holdToken.holdTotalCents.holdTotalCurrency.includeUnavailable.lastName.loyaltyCode.loyaltyText.memberId.messages.notes.phone.postalCode.publicKey.quotedAt.searchedAt.siteChoices.sites.state.status.subtotalCents.subtotalCurrency.taxCents.taxCurrency.taxes.termsAccepted.totalCents.totalCurrency.transactionFeeCents.transactionFeeCurrency.unitLength.unitTypeId.updatedAt
      .park((park) =>
        park.name.description.notes.terms.systemTerms.address.address2.city.state.postalCode.country.phone.email.notes.terms.logoUrl.leadDays.nextBookingDate.minNights.maxNights.creditCards.unitTypes(
          (unitType) => unitType.name.lengthMin.lengthMax.lengthRequired
        )
      )
      .unitType((unitType) => unitType.name.lengthMin.lengthMax.lengthRequired)
      .availabilities((availability) =>
        availability.description.descriptionLong.maxPeople.minTime.maxTime.reasonCodes.siteTypeId
          .siteType((siteType) => siteType.internalUid.uid)
          .bookingOptions(
            (bookingOption) =>
              bookingOption.description.fieldType.quantity.minValue.maxValue
                .personFlag
          )
      )
      .availability((availability) =>
        availability.description.descriptionLong.maxPeople.minTime.maxTime.reasonCodes.siteTypeId
          .siteType((siteType) => siteType.internalUid.uid)
          .bookingOptions(
            (bookingOption) =>
              bookingOption.description.fieldType.quantity.minValue.maxValue
                .personFlag
          )
      )
)

export const RootStore = RootStoreBase.extend(
  localStorageMixin({
    throttle: 1000,
    storageKey: `enterstate`,
  })
)
  .props({
    view: types.optional(ViewStore, {}),
  })
  .views((self) => ({
    get routing() {
      return getEnv(self).routing
    },
    get parkId() {
      return localStorage.getItem(`enterstate.parkId`)
    },
    get park() {
      return self.parkId && self.parks.get(self.parkId)
    },
    get bookingId() {
      return localStorage.getItem(`enterstate.bookingId`)
    },
    get booking() {
      return self.bookings.values().next().value
    },
  }))
  .actions((self) => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    },
    createBooking() {
      const bookingId = self.bookingId
      const input = {
        parkId: self.parkId,
      }
      if (bookingId) {
        input.id = bookingId
      }
      return self.mutateCreateBooking({ input: input }, BOOKING)
    },
    getBooking() {
      return self.getBooking({
        id: self.booking.id,
      })
    },
    saveTripDetails() {
      return self.mutateSaveTripDetails(
        {
          input: {
            ...self.booking.tripDetails,
            id: self.booking.id,
            action: 'search',
          },
        },
        BOOKING,
        () => (self.booking.availablity = undefined)
      )
    },
    savePickSite() {
      const {
        numericBookingOptions,
        booleanBookingOptions,
        ...rest
      } = self.booking.pickSite
      return self.mutateSavePickSite(
        {
          input: {
            bookingOptions: self.booking.currentBookingOptions.map((bo) => {
              const { id, quantity } = bo.toJSON()
              return { id, quantity }
            }),
            ...rest,
            id: self.booking.id,
            action: 'quote',
          },
        },
        BOOKING
      )
    },
    saveCheckout() {
      return self.mutateSaveCheckout(
        {
          input: {
            ...self.booking.checkout,
            id: self.booking.id,
            action: 'hold',
          },
        },
        BOOKING
      )
    },
    confirmBooking() {
      return self.mutateConfirmBooking(
        {
          input: {
            id: self.booking.id,
            action: 'confirm',
          },
        },
        BOOKING
      )
    },
    setBookingId(bookingId) {
      localStorage.setItem(`enterstate.bookingId`, bookingId)
    },
    setParkId(parkId) {
      const currentParkId = localStorage.getItem(`enterstate.parkId`)
      if (parkId) {
        localStorage.setItem(`enterstate.parkId`, parkId)
        if (parkId !== currentParkId) {
          self.startOver()
        }
      }
    },
    startOver() {
      localStorage.removeItem(`enterstate`)
      localStorage.removeItem(`enterstate.bookingId`)

      applySnapshot(self.__queryCache, {})
      applySnapshot(self, {})
      applySnapshot(self.view, {})

      self.view.afterCreate()
      window.location.replace('/')
    },
  }))
